import type { FC } from 'react';
import { Suspense } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { PageHeader } from 'src/components/layout/page-header';
import { Stack } from 'src/components/layout/stack';
import { RootRoutes } from 'src/components/root-routes';
import { PageSpinner } from 'src/components/spinner-container';
import { Assignments } from 'src/pages/operators/assignments';
import { ShipperInvoicesOverview } from 'src/pages/operators/invoices';
import { ShipperInvoiceDetail } from 'src/pages/operators/invoices/detail';
import { OperatorDocuments } from 'src/pages/operators/operator-documents';
import { OperatorsTabs } from 'src/pages/operators/operators-tabs';

export const Operators: FC = () => {
  return (
    <Stack gap={1}>
      <PageHeader title="Operators" />

      <OperatorsTabs />

      <Suspense fallback={<PageSpinner />}>
        <RootRoutes>
          {[
            '/operators/assignments/*',
            '/dashboard/operators/assignments/*',
          ].map((path) => (
            <Route key={path} path={path} element={<Assignments />} />
          ))}

          <Route
            path="/operators/operator-documents/*"
            element={<OperatorDocuments />}
          />

          <Route
            path="/operators/invoices/:invoiceId/*"
            element={<ShipperInvoiceDetail />}
          />

          <Route
            path="/operators/invoices/*"
            element={<ShipperInvoicesOverview />}
          />

          <Route
            path="/operators"
            element={<Navigate replace to="/operators/assignments/overview" />}
          />
          <Route
            path="/operators/user-assignments/*"
            element={<Navigate replace to="/operators/assignments/overview" />}
          />

          <Route path="*" element={<ThrowNotFound />} />
        </RootRoutes>
      </Suspense>
    </Stack>
  );
};
